<template>
  <div>
    <Banner/>
    <WhatIs/>
    <Partners/>
    <Service/>
    <Challenges/>
    <Contact/>
  </div>
</template>
<script>
import Banner from './Banner'
import WhatIs from './WhatIs'
import Partners from './Partners'
import Service from './Service'
import Challenges from './Challenges'
import Contact from './Contact'
export default {
  components: {
    Banner,
    WhatIs,
    Partners,
    Service,
    Challenges,
    Contact
    
  }
}
</script>